import classnames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { blockUi, unBlockUi } from '../../../actions/actionCreator';
import {
  CASE_STATUS_LEVEL_LOOKUP_TABLE,
  CREATE_CASE_PAGE_ROUTES,
  HSBC_UK,
  HSBC_UK_PLC,
  achPaymentTypeMap
} from '../../../constants';
import { eapiClient } from '../../../restClient';
import { Translations, convertStringToArray, convertStringToArrayForOption, getConcatenatedStringFromValues, isEmptyObject } from '../../../utils';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../Modal';
import CaseBodyListActions from './CaseBodyListActions';
import CaseBodyProductListStatus from './CaseBodyProductListStatus';
import CustList from './CustList';

import Radio from '../../common/Radio/radioButton';
import SimpleDropdown from '../SimpleDropdown';
import './NavList.css';

class NavigationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteProductDialog: false,
      showAchPaymentTypeDialog: false,
      achPaymentType: '',
      clickedAchProductCountry: ''
    };
    this.clickedCurrentAchProductId = null;
    this.currentProductToBeDeleted = {};
  }

  _onDeleteProductOk = () => {
    const { caseId, productType, productId } = this.currentProductToBeDeleted;
    var apiURI;
    if (productType === "accounts") {
      apiURI = "/product/accounts/";
    } else if (productType === "echannels") {
      apiURI = "/product/echannels/";
    } else if (productType === "glsproducts") {
      if (this.props.productType === "gls-sow" && productId) {
        apiURI = "/sows/" + productId + "/deleteGlsProduct";
      } else {
        apiURI = "/product/glses/";
      }
    } else if (productType === "achCredit") {
      apiURI = "/product/ach-credit/";
    } else if (productType === "corporateCard") {
      apiURI = "/product/corporate-card/";
    } else if (productType === "cff") {
      apiURI = "/product/cff/";
    }

    const apiURL = productType === "glsproducts" && this.props.productType === "gls-sow" ? apiURI : apiURI + productId
    eapiClient(apiURL, {
      method: "DELETE"
    })
      .then(({ data, status }) => {
        if (status === 200) {
          this.toggleDeleteProductDialog();
          this.props.deleteProduct(caseId, productType, productId);
        }
      });
  }

  toggleDeleteProductDialog = () => {
    this.setState({ showDeleteProductDialog: false });
  }

  toggleAchPaymentTypeDialog = () => {
    this.setState({ showAchPaymentTypeDialog: false });
  }

  _onCancleAchPaymentType = () => {
    this.toggleAchPaymentTypeDialog();
  }

  getAchPaymentTypeTaxonomyId = (country, paymentType) => {
    switch (country) {
      case HSBC_UK:
        return achPaymentTypeMap[HSBC_UK][paymentType];
      case HSBC_UK_PLC:
        return achPaymentTypeMap[HSBC_UK_PLC][paymentType];
      default:
        return '';
    }
  }

  _onAchProductTypeOk = () => {
    let achPaymentTypePayloadObj = {};
    const achPaymentTypeTaxonomyId = this.getAchPaymentTypeTaxonomyId(this.state.clickedAchProductCountry, this.state.achPaymentType);

    achPaymentTypePayloadObj.paymentType = {
      name: this.state.achPaymentType,
      value: achPaymentTypeTaxonomyId
    }

    // API call to send the payment type payload
    eapiClient(`/product/ach/${this.clickedCurrentAchProductId}/cmp`, {
      method: 'PUT',
      data: JSON.stringify(achPaymentTypePayloadObj),
      timeout: 100000,
      noBlocking: false
    })
      .then(({ data, status }) => {
        if (status === 200) {
          this.setState({ showAchPaymentTypeDialog: false });
          /* blockUi() and unBlockUi() invoked by the reloadProductRequests method */
          // this.props.blockUi();
          this.props.reloadProductRequests();
          // this.props.unBlockUi();
        }
      })
      .catch(error => {
        console.log('Error [!!!]: ', error);
      })

    // this.setState({ showAchPaymentTypeDialog: false });
  }

  setRadioSelection = (value, name) => {
    this.setState({ achPaymentType: value });
  }

  confrimDeleteProduct = (caseId, productType, productId) => {
    this.currentProductToBeDeleted = { caseId, productType, productId };
    this.setState({ showDeleteProductDialog: true });
  }

  confrimDeleteProductOnEnter = (caseId, productType, productId, event) => {
    if (event.key === "Enter") {
      this.currentProductToBeDeleted = { caseId, productType, productId };
      this.setState({ showDeleteProductDialog: true });
    }
  }

  parseFetchResponse = (response) => response.json().then(json => ({
    data: json,
    meta: response
  }))

  splitVal = (str = "") => {
    return (str.split(":")).pop();
  }

  toEditProductPage = (pageReferer, id, caseId, event) => {
    this.props.history.push(CREATE_CASE_PAGE_ROUTES[this.props.pageReferer] + '/' + caseId + '/' + id);
  }

  toEditProductPageOnEnter = (pageReferer, id, caseId, event) => {
    if (event.key === "Enter") {
      this.props.history.push(CREATE_CASE_PAGE_ROUTES[this.props.pageReferer] + '/' + caseId + '/' + id);
    }
  }

  toViewEntityProfilePage = (entityId, event) => {
    this.props.history.push('/view-entity-profile/' + entityId);
  }
  toViewEntityProfilePageOnEnter = (entityId, event) => {
    if (event.key === "Enter") {
      this.props.history.push('/view-entity-profile/' + entityId);
    }
  }

  toCaptureCustomerDetails = (entityId, caseId) => {
    this.props.history.push('/case-body/capture-customer-details/' + entityId + '/' + caseId);
  }
  toCaptureCustomerDetailsOnEnter = (entityId, caseId, event) => {
    if (event.key === "Enter") {
      this.props.history.push('/case-body/capture-customer-details/' + entityId + '/' + caseId);
    }
  }
  toCaptureProductAccount = (caseId, productId) => {
    this.props.history.push('/case-body/capture-product-account/' + caseId + '/' + productId);
  }
  toCaptureProductGlsOnEnter = (caseId, productId, type, productType, glsProduct, event,) => {
    if (event.key === "Enter") {
      if (type === 'cashcon') {
        if (productType === "gls-sow") {
          this.props.setSowAgent()
          this.props.history.push(`/sow/body/cash-con-summary/${productId}`)
        } else {
          this.props.history.push('/case-body/capture-product-cashcon/' + caseId + '/' + productId);
        }
      } else if (type === 'notionalPool') {
        if (productType === "gls-sow") {
          this.props.setSowAgent();
          this.props.setSowSelectedProduct(glsProduct);
          this.props.history.push('/sow-body/capture-product-notional-pooling/' + caseId + '/' + productId);
        } else {
          this.props.history.push('/case-body/capture-product-notional-pooling/' + caseId + '/' + productId);
        }
      } else if (type === 'interest') {
        if (productType === "gls-sow") {
          this.props.setSowAgent();
          this.props.setSowSelectedProduct(glsProduct);
          this.props.history.push('/sow-body/capture-product-interest-enhancement/' + caseId + '/' + productId);
        } else {
          this.props.history.push('/case-body/capture-product-interest-enhancement/' + caseId + '/' + productId);
        }
      }
    }
  }

  toCaptureProductEchannel = (caseId, productId) => {
    this.props.history.push('/case-body/capture-product-echannel/' + caseId + '/' + productId);
  }
  toCaptureProductEchannelOnEnter = (caseId, productId, event) => {
    if (event.key === "Enter") {
      this.props.history.push('/case-body/capture-product-echannel/' + caseId + '/' + productId);
    }
  }

  toCaptureProductGls = (caseId, productId, type, productType, glsProduct) => {
    if (type === 'cashcon') {
      if (productType === "gls-sow") {
        this.props.setSowAgent()
        this.props.history.push(`/sow/body/cash-con-summary/${productId}`)
      } else {
        this.props.history.push('/case-body/capture-product-cashcon/' + caseId + '/' + productId);
      }
    } else if (type === 'notionalPool') {
      if (productType === "gls-sow") {
        this.props.setSowAgent();
        this.props.setSowSelectedProduct(glsProduct);
        this.props.history.push('/sow-body/capture-product-notional-pooling/' + caseId + '/' + productId);
      } else {
        this.props.history.push('/case-body/capture-product-notional-pooling/' + caseId + '/' + productId);
      }
    } else if (type === 'interest') {
      if (productType === "gls-sow") {
        this.props.setSowAgent();
        this.props.setSowSelectedProduct(glsProduct);
        this.props.history.push('/sow-body/capture-product-interest-enhancement/' + caseId + '/' + productId);
      } else {
        this.props.history.push('/case-body/capture-product-interest-enhancement/' + caseId + '/' + productId);
      }
    }
  }
  toCaptureAdditionalData = (countryFormName, caseId, productId) => {
    if (countryFormName === "India declaration letter") {
      this.props.history.push('/case-body/country-forms/india-declaration-form/' + caseId + '/' + productId);
    } else if (countryFormName === "France law MURCEF") {
      this.props.history.push('/case-body/country-forms/france-law-murcef-form/' + caseId + '/' + productId);
    } else if (countryFormName === "Spain Declaration of Tax Residence") {
      this.props.history.push('/case-body/country-forms/spain-declaration-of-tax-residence-form/' + caseId + '/' + productId);
    } else if (countryFormName === "Canada - Personal Info Consent") {
      this.props.history.push('/case-body/country-forms/canada-personal-information-consent-form/' + caseId + '/' + productId);
    } else if (countryFormName === "Poland hsbcnet user notification - Person") {
      this.props.history.push('/case-body/country-forms/poland-hsbc-net-user-notification-form/' + caseId + '/' + productId);
    } else if (countryFormName === "Australia Authorised Referee Form") {
      this.props.history.push('/case-body/country-forms/australia-authorised-referee-form/' + caseId + '/' + productId);
    } else if (countryFormName === "Czech - Suggested Personal Data Processing Consent") {
      this.props.history.push('/case-body/country-forms/czech-republic-personal-data-consent-form/' + caseId + '/' + productId);
    } else if (countryFormName === "Italy Account Signatory Declaration Form") {
      this.props.history.push('/case-body/country-forms/italy-account-signatory-form2-form/' + caseId + '/' + productId);
    }
  }

  toCaptureAdditionalDataOnEnter = (countryFormName, caseId, productId, event) => {
    if (event.key === "Enter") {
      if (countryFormName === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:India") {
        this.props.history.push('/case-body/country-forms/india-declaration-form/' + caseId + '/' + productId);
      } else if (countryFormName === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:France") {
        this.props.history.push('/case-body/country-forms/france-law-murcef-form/' + caseId + '/' + productId);
      } else if (countryFormName === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:Spain") {
        this.props.history.push('/case-body/country-forms/spain-declaration-of-tax-residence-form/' + caseId + '/' + productId);
      } else if (countryFormName === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:Canada") {
        this.props.history.push('/case-body/country-forms/canada-personal-information-consent-form/' + caseId + '/' + productId);
      }
    }
  }

  toCaptureProductAchCredit = (caseId, productId, country, paymentType) => {
    if ((country === HSBC_UK || country === HSBC_UK_PLC) && !paymentType) {
      this.setState({ achPaymentType: '' });
      this.setState({ clickedAchProductCountry: country });
      this.setState({ showAchPaymentTypeDialog: true });
      this.clickedCurrentAchProductId = productId;
    } else {
      this.props.history.push('/case-body/capture-product-ach/' + productId + '/' + caseId)
    }
  }

  toCaptureProductAchCreditOnEnter = (caseId, productId, country, paymentType, event) => {
    if (event.key === "Enter" || event.keyCode === 13) {
      if ((country === HSBC_UK || country === HSBC_UK_PLC) && !paymentType) {
        this.setState({ achPaymentType: '' });
        this.setState({ clickedAchProductCountry: country });
        this.setState({ showAchPaymentTypeDialog: true });
        this.clickedCurrentAchProductId = productId;
      } else {
        this.props.history.push('/case-body/capture-product-ach/' + productId + '/' + caseId)
      }
    }
  }

  toCaptureProductCorporateCard = (caseId, productId, event) => {
    this.props.history.push('/case-body/capture-product-corporate-card/' + caseId + '/' + productId);
  }

  toCaptureProductCorporateCardOnEnter = (caseId, productId, event) => {
    if (event.key === "Enter") {
      this.props.history.push('/case-body/capture-product-corporate-card/' + caseId + '/' + productId);
    }
  }

  redirectToCaptureProductCashFlowForecasting = (caseId, productId, event) => {
    if ((event && event.key === "Enter") || !event) {
      this.props.history.push('/case-body/capture-product-cash-flow-forecasting/' + caseId + '/' + productId);
    }
  }

  getAccountCountryTaxanomy = (item) => {
    let countryListTaxonomy = this.props.countryList || this.props.accountCountryList;
    if (countryListTaxonomy !== undefined) {
      countryListTaxonomy.filter(countItem => {
        if ('country' in item) {
          if (countItem.id === item.country.value) {
            item.country.name = countItem.name
            if (item.accountType !== undefined) {
              countItem.associations.filter(accountType => {
                if (accountType.id === item.accountType.value) {
                  item.accountType.name = accountType.name
                }
              })
            }
          }
        }
        else if ('cof' in item) {
          if (countItem.id === item.cof.value) {
            item.cof.name = countItem.name
          }
        }
        return item;
      });
      return item;
    }
  }

  getGlsProductType(item) {
    if (this.props.options !== '' && this.props.options !== undefined) {

      const productType = convertStringToArrayForOption(this.props.options);
      if (productType !== undefined) {
        productType.filter(countItem => {
          if (countItem.split('=')[0] === item.glsProductType.value) {
            item.glsProductType.name = countItem.split('=')[1]
          }
        })
        return item;
      }
    } else {
      return item
    }
  }

  accountVersionList(elements) {
    if (this.props.cases !== undefined) {
      for (var caseId in this.props.cases) {
        var _case = this.props.cases[caseId];
        if (this.props.pageReferer === "accountPage") {
          var account;
          for (var accountId in _case.accounts) {
            account = _case.accounts[accountId];
            let translatedAccount = this.props.countryList !== undefined ? this.getAccountCountryTaxanomy(account) : account;
            elements.push(
              <div key={accountId} className='navListSeparator'>
                <div className="gdocs-float-left">
                  <div onKeyDown={this.toEditProductPageOnEnter.bind(this, this.props.pageReferer, accountId, _case.caseId)} onClick={this.toEditProductPage.bind(this, this.props.pageReferer, accountId, _case.caseId)} className='navListAccHeading linkCursor' tabIndex="0" role="link">
                    {`${translatedAccount.accountType.name}, ${translatedAccount.country.name},  ${account.currency.name}`}

                  </div>
                  <div className="navListDesc">{`${_case.entityName} (${account.accountTitle ? account.accountTitle + ', ' : ''}${account.tempRefrenceId})`} </div>
                </div>
                <div className="gdocs-float-right">
                  <div className="separatorBar gdocs-float-left"></div>
                  <button className="icon icon-bin deleteIcon gdocs-float-left" aria-label="Delete Product" tabIndex="0" dir={account.id} id={account.id}
                    onKeyDown={this.confrimDeleteProductOnEnter.bind(this, _case.caseId, 'accounts', account.id)}
                    onClick={this.confrimDeleteProduct.bind(this, _case.caseId, 'accounts', account.id)}></button>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            );
          }
        }
        else if (this.props.pageReferer === "echannelPage") {
          var echannel;
          for (var echannelId in _case.echannels) {
            echannel = _case.echannels[echannelId];
            let translatedEchannel = this.props.countryList !== undefined ? this.getAccountCountryTaxanomy(echannel) : echannel;
            elements.push(
              <div key={echannelId} className='navListSeparator'>
                <div className="gdocs-float-left">
                  <div onKeyDown={this.toEditProductPageOnEnter.bind(this, this.props.pageReferer, echannelId, _case.caseId)} onClick={this.toEditProductPage.bind(this, this.props.pageReferer, echannelId, _case.caseId)} className='navListAccHeading linkCursor' tabIndex="0" role="link">
                    {`${translatedEchannel.eChannelType.name}, ${translatedEchannel.country.name},  (${echannel.newEchannel ? this.translations(this.props.pageJson.par.navigation_list_eChannelList.new) : `${this.translations(this.props.pageJson.par.navigation_list_eChannelList.existingID)}:${echannel.eChannelId}`})`}

                  </div>
                  <div className='navListDesc'>{echannel.profileOwner.name}</div>
                </div>
                <div className="gdocs-float-right">
                  <div className="separatorBar gdocs-float-left"></div>
                  <button className="icon icon-bin deleteIcon gdocs-float-left" aria-label="Delete Product" dir={echannel.id} id={echannel.id}
                    onKeyDown={this.confrimDeleteProductOnEnter.bind(this, _case.caseId, 'echannels', echannel.id)}
                    onClick={this.confrimDeleteProduct.bind(this, _case.caseId, 'echannels', echannel.id)}></button>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            );
          }
        }
        else if (this.props.pageReferer === "glsPage") {
          var glsproduct;
          for (var glsproductId in _case.glsproducts) {
            glsproduct = _case.glsproducts[glsproductId];
            glsproduct = this.getGlsProductType(glsproduct);
            let title = glsproduct.notionalPoolingTitle || glsproduct.cashConTitle || glsproduct.interestEnhancementTitle;
            elements.push(
              <div key={glsproductId} className='navListSeparator'>
                <div className="gdocs-float-left">
                  <div
                    onKeyDown={this.toEditProductPageOnEnter.bind(this, this.props.pageReferer, glsproductId, _case.caseId)}
                    onClick={this.toEditProductPage.bind(this, this.props.pageReferer, glsproductId, _case.caseId)}
                    className='navListAccHeading linkCursor'
                    tabIndex="0"
                    role="link"
                  >
                    {glsproduct.glsProductType.name}

                  </div>
                  <div className='navListDesc gdocs-responsive-text'>
                    {`Agent: ${glsproduct.glsAgent.name} ${title ? '(' + title + ')' : ''}`}
                  </div>
                </div>
                <div className="gdocs-float-right">
                  <div className="separatorBar gdocs-float-left"></div>
                  <button
                    className="icon icon-bin deleteIcon gdocs-float-left"
                    aria-label="Delete Product"
                    tabIndex="0"
                    dir={glsproduct.id}
                    id={glsproduct.id}
                    onKeyDown={this.confrimDeleteProductOnEnter.bind(this, _case.caseId, 'glsproducts', glsproduct.id)}
                    onClick={this.confrimDeleteProduct.bind(this, _case.caseId, 'glsproducts', glsproduct.id)}
                  >
                  </button>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            );
          }
        }
      }
    }
  }

  getCountryTaxanomy = (name, Id) => {
    if (this.props.countryTaxanomy !== undefined && this.props.countryTaxanomy.length !== 0) {
      let taxanomy = this.props.countryTaxanomy;
      let country = taxanomy.filter(item => item.id === Id);
      return country[0].name;
    }
    else {
      return name;
    }
  }

  allProductlist(elements) {
    if (this.props.productDetailsdata) {
      const { account: accounts, echannel: echannels, gls: glsProducts, achCredit: achCredits, additionalData: countryForms, corporateCard: corporateCards, cashFlowForecasting } = this.props.productDetailsdata;
      // let accounts = account;
      // let echannels = echannel;
      // const glsProducts = gls;
      // let achCredits = achCredit;
      // const countryForms = additionalData;
      // const corporateCards = corporateCard;
      // const {accounts, echannels, glsProducts, countryForms} = this.props.productDetailsdata;
      if (this.props.pageReferer === "newAccount" && accounts !== undefined) {
        accounts.forEach(account => {
          let translatedAccount = this.props.accountCountryList !== undefined ? this.getAccountCountryTaxanomy(account) : account;
          elements.push(
            <NavlistWrapper key={account.id} block={this.props.cases && this.props.cases[account.caseId] && CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[account.caseId].status] > 2 || this.props.caseMenu.isEditing}>
              <div key={account.id} className='navListSeparator'>
                <div className="gdocs-float-left" style={{ width: '78%' }}>
                  <div className='navListAccHeading linkCursor'>
                    <Link to={'/case-body/capture-product-account/' + account.id + '/' + account.caseId}>
                      {getConcatenatedStringFromValues(translatedAccount.accountType && translatedAccount.accountType.name, translatedAccount.country && translatedAccount.country.name, account.currency && account.currency.name)}
                    </Link>
                  </div>
                  <div className="navListDesc">
                    {
                      `${account.accountHolder && account.accountHolder.name || ''}` +
                      `${account.accountTitle || account.tempRefrenceId ? " (" + getConcatenatedStringFromValues(account.accountTitle, account.tempRefrenceId) + ")" : ""}`
                    }
                  </div>
                </div>
                <div className="gdocs-float-right">
                  <div className="gdocs-float-left">
                    <CaseBodyProductListStatus status={account.productStatus} lang={this.props.lang.currentLang.lang} />
                  </div>
                  <div className="adjustDeleteIcon">
                    <div className="separatorBar gdocs-float-left"></div>
                    <button className="icon icon-bin deleteIcon gdocs-float-left" tabIndex="0" aria-label="Delete Product"
                      onKeyDown={this.confrimDeleteProductOnEnter.bind(this, account.accountHolder.value, 'accounts', account.id)} onClick={this.confrimDeleteProduct.bind(this, account.accountHolder.value, 'accounts', account.id)} ></button>
                  </div>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            </NavlistWrapper>
          );
        });
      } else if (this.props.pageReferer === "echannel" && echannels !== undefined) {
        echannels.forEach(echannel => {
          let translatedEchannel = this.props.countryList !== undefined ? this.getAccountCountryTaxanomy(echannel) : echannel;
          elements.push(
            <NavlistWrapper key={echannel.id} block={(this.props.cases && this.props.cases[echannel.caseId] && this.props.cases[echannel.caseId].status) && CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[echannel.caseId].status] > 2 || this.props.caseMenu.isEditing}>
              <div className='navListSeparator'>
                <div className="gdocs-float-left">
                  <div onKeyDown={this.toCaptureProductEchannelOnEnter.bind(this, echannel.id, echannel.caseId)}
                    onClick={this.toCaptureProductEchannel.bind(this, echannel.id, echannel.caseId)}
                    className='navListAccHeading linkCursor'
                    tabIndex="0"
                    role="link">
                    {`${echannel.eChannelType ? echannel.eChannelType.name + "," : ''} ${translatedEchannel.country.name},  
                    (${echannel.newEchannel ? `${this.props.newEchannelKey}` : `${this.props.existingEchannelKey}: ${echannel.eChannelId}`})`}
                  </div>
                  <div className="navListDesc">
                    {`${echannel.profileOwner.name} ${echannel.newEchannel && echannel.tempRefrenceId ? "(" + echannel.tempRefrenceId + ")" : ''}`}
                  </div>
                </div>
                <div className="gdocs-float-right">
                  <div className="gdocs-float-left">
                    <CaseBodyProductListStatus status={echannel.productStatus} lang={this.props.lang.currentLang.lang} />
                  </div>
                  <div className="adjustDeleteIcon">
                    <div className="separatorBar gdocs-float-left"></div>
                    <button className="icon icon-bin deleteIcon gdocs-float-left" tabIndex="0" aria-label="Delete Product"
                      onKeyDown={this.confrimDeleteProductOnEnter.bind(this, echannel.profileOwner.value, 'echannels', echannel.id)}
                      onClick={this.confrimDeleteProduct.bind(this, echannel.profileOwner.value, 'echannels', echannel.id)} ></button>
                  </div>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            </NavlistWrapper>
          );
        });
      } else if (this.props.pageReferer === "gls" && glsProducts !== undefined) {
        glsProducts.forEach(glsProduct => {
          glsProduct = this.getGlsProductType(glsProduct);
          let { caseId, id, productStatus, sowCaseId } = glsProduct;
          const title = glsProduct.cashConTitle || glsProduct.notionalPoolingTitle || glsProduct.interestEnhancementTitle;
          if (glsProduct) {
            elements.push(
              <NavlistWrapper key={id} block={this.getProductStateDisabled(this.props.productType, glsProduct, caseId)}>
                <div className={this.props.productType === "gls-sow" ? ((this.props.isReadOnly && this.props.isReadOnly(true)) ?
                  'gls-sow navListSeparator disabled' : 'gls-sow navListSeparator') : 'navListSeparator'}>
                  <div className="gdocs-float-left">
                    <div onKeyDown={this.toCaptureProductGlsOnEnter.bind(this, this.props.productType === "gls-sow" ? sowCaseId : caseId, id, glsProduct.glsProductType.value, this.props.productType, glsProduct)}
                      onClick={
                        this.toCaptureProductGls.bind(this, this.props.productType === "gls-sow" ? sowCaseId : caseId, id, glsProduct.glsProductType.value, this.props.productType, glsProduct)}
                      className='navListAccHeading linkCursor'
                      tabIndex="0"
                      role="link">
                      {glsProduct.glsProductType.name}
                    </div>
                    <div className="navListDesc gdocs-responsive-text">{`${this.props.agentText}: ${glsProduct.glsAgent.name} ${title ? '(' + title + ')' : ''} `}</div>
                  </div>
                  <div className="gdocs-float-right">
                    <div className="gdocs-float-left">
                      <CaseBodyProductListStatus status={productStatus} lang={this.props.lang.currentLang.lang} />
                    </div>
                    <div className="adjustDeleteIcon">
                      <div className="separatorBar gdocs-float-left"></div>
                      <button
                        className="icon icon-bin deleteIcon gdocs-float-left"
                        tabIndex="0"
                        aria-label="Delete Product"
                        onKeyDown={this.confrimDeleteProductOnEnter.bind(this, glsProduct.glsAgent.value, 'glsproducts', id)}
                        onClick={this.confrimDeleteProduct.bind(this, glsProduct.glsAgent.value, 'glsproducts', id)}
                        disabled={(this.props.customer && this.props.customer.roleDetails.customer) || (this.props.isCustAck)}
                      >
                      </button>
                    </div>
                  </div>
                  <div className="gdocs-clear-float"></div>
                </div>
              </NavlistWrapper>
            );
          }
        });
      } else if (this.props.pageReferer === "additionalData" && countryForms !== undefined) {
        countryForms.forEach((countryForm, index) => {
          const { caseId, productId } = countryForm;
          elements.push(
            <NavlistWrapper key={index} block={this.props.cases && this.props.cases[caseId] && CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId].status] > 2 || this.props.caseMenu.isEditing}>
              <div className='navListSeparator'>
                <div className="gdocs-float-left">
                  <div className='navListAccHeading linkCursor'
                    onClick={this.toCaptureAdditionalData.bind(this, countryForm.countryFormName, caseId, productId)}
                    onKeyDown={this.toCaptureAdditionalDataOnEnter.bind(this, countryForm.countryFormName, caseId, productId)}
                    tabIndex="0" role="link">
                    {countryForm.countryFormName}

                  </div>
                  <div className="navListDesc">{countryForm.entityName}</div>
                </div>
                <div className="gdocs-float-right">
                  <div className="gdocs-float-left">
                    <CaseBodyProductListStatus status={countryForm.status} lang={this.props.lang.currentLang.lang} />
                  </div>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            </NavlistWrapper>
          );
        });
      } else if (this.props.pageReferer === "achCredit" && achCredits !== undefined) {
        achCredits.forEach(achItem => {
          let translatedAchItem = this.props.countryList !== undefined ? this.getAccountCountryTaxanomy(achItem) : achItem;
          let { caseId, id } = achItem;
          elements.push(
            <NavlistWrapper key={id} block={this.props.cases && this.props.cases[caseId] && CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId].status] > 2 || this.props.caseMenu.isEditing}>
              <div className='navListSeparator'>
                <div className="gdocs-float-left">
                  <div className='navListAccHeading linkCursor'
                    tabIndex="0" role="link"
                    onKeyDown={this.toCaptureProductAchCreditOnEnter.bind(this, achItem.caseId, achItem.id, translatedAchItem.country.name, achItem.paymentType ? achItem.paymentType.name : '')}
                    onClick={this.toCaptureProductAchCredit.bind(this, achItem.caseId, achItem.id, translatedAchItem.country.name, achItem.paymentType ? achItem.paymentType.name : '')}
                  >
                    {/* {`${translatedAchItem.country.name}${achItem.paymentType.name ? ', ' + achItem.paymentType.name : ''}`} */}
                    {getConcatenatedStringFromValues(translatedAchItem.country.name, achItem.paymentType && achItem.paymentType.name)}
                  </div>
                  <div className="navListDesc">{`${achItem.achAgent.name}`} </div>
                </div>
                <div className="gdocs-float-right">
                  <div className="gdocs-float-left">
                    <CaseBodyProductListStatus status={achItem.productStatus} lang={this.props.lang.currentLang.lang} />
                  </div>
                  <div className="adjustDeleteIcon">
                    <div className="separatorBar gdocs-float-left"></div>
                    <button className="icon icon-bin deleteIcon gdocs-float-left" tabIndex="0" aria-label="Delete Product"
                      onKeyDown={this.confrimDeleteProductOnEnter.bind(this, achItem.achAgent.value, 'achCredit', achItem.id)}
                      onClick={this.confrimDeleteProduct.bind(this, achItem.achAgent.value, 'achCredit', achItem.id)} ></button>
                  </div>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            </NavlistWrapper>
          );
        });
      } else if (this.props.pageReferer === "corporateCard" && corporateCards !== undefined) {
        corporateCards.forEach(ccItem => {
          let translatedCCItem = this.props.countryList !== undefined ? this.getAccountCountryTaxanomy(ccItem) : ccItem;
          let { caseId, id } = ccItem;
          elements.push(
            <NavlistWrapper key={id} block={this.props.cases && this.props.cases[caseId] && CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId].status] > 2 || this.props.caseMenu.isEditing}>
              <div className='navListSeparator'>
                <div className="gdocs-float-left">
                  <div className='navListAccHeading linkCursor'
                    tabIndex="0" role="link"
                    onKeyDown={this.toCaptureProductCorporateCardOnEnter.bind(this, ccItem.id, ccItem.caseId)}
                    onClick={this.toCaptureProductCorporateCard.bind(this, ccItem.id, ccItem.caseId)}>
                    {`${translatedCCItem.country.name}`}

                  </div>
                  <div className="navListDesc">{`${ccItem.corporateCardAgent.name}`} </div>
                </div>
                <div className="gdocs-float-right">
                  <div className="gdocs-float-left">
                    <CaseBodyProductListStatus status={ccItem.productStatus} lang={this.props.lang.currentLang.lang} />
                  </div>
                  <div className="adjustDeleteIcon">
                    <div className="separatorBar gdocs-float-left"></div>
                    <button className="icon icon-bin deleteIcon gdocs-float-left" tabIndex="0" aria-label="Delete Product"
                      onKeyDown={this.confrimDeleteProductOnEnter.bind(this, ccItem.corporateCardAgent.value, 'corporateCard', ccItem.id)}
                      onClick={this.confrimDeleteProduct.bind(this, ccItem.corporateCardAgent.value, 'corporateCard', ccItem.id)} ></button>
                  </div>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            </NavlistWrapper>
          );
        });
      } else if (this.props.pageReferer === "cashFlowForecasting" && (Array.isArray(cashFlowForecasting) && cashFlowForecasting.length)) {
        cashFlowForecasting.forEach(cffItem => {
          const translatedCCItem = this.props.countryList !== undefined ? this.getAccountCountryTaxanomy(cffItem) : cffItem;
          const { caseId, id } = cffItem;
          elements.push(
            <NavlistWrapper key={id} block={this.props.cases && this.props.cases[caseId] && CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId] && this.props.cases[caseId].status] > 2 || this.props.caseMenu.isEditing}>
              <div className='navListSeparator'>
                <div className="gdocs-float-left">
                  <div className='navListAccHeading linkCursor'
                    tabIndex="0" role="link"
                    onKeyDown={(e) => this.redirectToCaptureProductCashFlowForecasting(cffItem.id, cffItem.caseId, e)}
                    onClick={() => this.redirectToCaptureProductCashFlowForecasting(cffItem.id, cffItem.caseId)}>
                    {`${translatedCCItem.country.name}`}

                  </div>
                  <div className="navListDesc">{`${cffItem.cffAgent.name}`} </div>
                </div>
                <div className="gdocs-float-right">
                  <div className="gdocs-float-left">
                    <CaseBodyProductListStatus status={cffItem.productStatus} lang={this.props.lang.currentLang.lang} />
                  </div>
                  {!isEmptyObject(this.props.customer) && !this.props.customer.roleDetails.customer ?
                    <div className="adjustDeleteIcon">
                      <div className="separatorBar gdocs-float-left"></div>
                      <button className="icon icon-bin deleteIcon gdocs-float-left" tabIndex="0" aria-label="Delete Product"
                        onKeyDown={this.confrimDeleteProductOnEnter.bind(this, cffItem.cffAgent.value, 'cff', cffItem.id)}
                        onClick={this.confrimDeleteProduct.bind(this, cffItem.cffAgent.value, 'cff', cffItem.id)} ></button>
                    </div>
                    : null
                  }
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            </NavlistWrapper>
          );
        });
      }

      if (this.props.pageReferer === "notionalPoolingList") {
        const { productDetailsdata, pageJson } = this.props;
        productDetailsdata.forEach((data, index) => {
          const { accounts, poolCurrency, id, refrenceId } = data;
          const accountLenght = accounts.length || 0;
          elements.push(
            <NavlistWrapper key={index} block={false}>
              <div className='navListSeparator'>
                <ul>
                  <li>
                    <div className="gdocs-float-left">
                      <div onClick={(event) => this.props.redirectToForm(event, id)} className='navListAccHeading linkCursor' tabIndex="0" role="link">
                        {refrenceId} {poolCurrency !== undefined && poolCurrency.name !== undefined && poolCurrency.name !== '' ? `(${poolCurrency.name})` : ''}

                      </div>
                    </div>
                  </li>
                  <li>
                    <ul>
                      <li>{this.translations(pageJson.singleCurrency)}</li>
                      <li>{poolCurrency !== undefined ? poolCurrency.name : ''}</li>
                      <li>{accountLenght} {this.translations(pageJson.accounts)}</li>
                      {
                        this.props.customer !== undefined && !this.props.customer.roleDetails.customer
                          ? <li><i className="icon icon-bin" onClick={(event) => this.props.deletePool(event, id)}></i> </li>
                          : ''
                      }
                    </ul>
                  </li>
                </ul>
              </div>
            </NavlistWrapper>
          );
        });
      }

      if (this.props.pageReferer === "notionalPoolingStandaloneList") {

        const { productDetailsdata, pageJson, accounts, productType } = this.props;

        productDetailsdata.forEach((data, index) => {

          if (typeof accounts !== 'undefined') {
            let accountFlter = accounts.filter(item => item.id === data);
            let account = accountFlter[0];
            if (account !== undefined) {
              elements.push(
                <NavlistWrapper key={index} block={false}>
                  <div className='navListSeparator'>
                    <ul>
                      <li>
                        <div className="linkCursor" onClick={this.props.addStandaloneEvent}>
                          <span>
                            {
                              productType === "gls-sow" ?
                                this.getGlsSowStandAloneAccountList(account)
                                :
                                account.otherAccount !== undefined && 'otherAccount' in account && account.otherAccount === true
                                  ? <b>
                                    {`${account.accountNumber !== undefined ? account.accountNumber + ',' : ''}`}
                                    {`${account.branchCode !== undefined ? account.branchCode + ',' : ''}`}
                                    {`${account.country !== undefined && account.country.name !== undefined ? this.getCountryTaxanomy(account.country.name, account.country.value) + ',' : ''}`}
                                    {`${account.currency !== undefined && account.currency.name !== undefined ? account.currency.name : ''}`}
                                  </b>
                                  : <b>
                                    {`${account.accountType !== undefined ? account.accountType.name + ',' : ''}`}
                                    {`${account.country !== undefined && account.country.name !== undefined ? this.getCountryTaxanomy(account.country.name, account.country.value) + ',' : ''}`}
                                    {`${account.currency !== undefined && account.currency.name !== undefined ? account.currency.name + ',' : ''}`}
                                  </b>
                            }
                          </span>
                          <p>
                            {`${account.accountHolder !== undefined ? account.accountHolder.name : ''}`}

                          </p>
                          <p>{account.accountTitle !== undefined ? `(${account.accountTitle})` : ''}</p>
                        </div>
                      </li>
                      <li>
                        <ul>
                          <li>{this.translations(pageJson.standaloneAccount)}</li>
                          <li>{account.currency.name}</li>
                          <li></li>
                          {
                            this.props.customer !== undefined && !this.props.customer.roleDetails.customer
                              ? <li><i className="icon icon-bin" onClick={(event) => this.props.deleteStandAloneAccount(event, accountFlter[0].id)}></i> </li>
                              : ''
                          }
                        </ul>
                      </li>
                    </ul>
                  </div>
                </NavlistWrapper>);
            }
          }
        });
      }
    }
  }

  getGlsSowStandAloneAccountList = (account = {}) => {
    return (
      <strong>
        {`${account.accountNumber !== undefined ? account.accountNumber + ',' : ''}`}
        {`${account.location !== undefined && account.location.name !== undefined ? this.getCountryTaxanomy(account.location.name, account.location.value) + ',' : ''}`}
        {`${account.currency !== undefined && account.currency.name !== undefined ? account.currency.name : ''}`}
      </strong>

    )
  }

  getProductStateDisabled = (type, product, caseId) => {
    if (type === "gls-sow") {
      return product.disabled
    }
    return this.props.cases && this.props.cases[caseId] &&
      CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId].status] > 2 || this.props.caseMenu.isEditing
  }

  checkResolve(_case) {
    if (this.props.listtype === "caseBodyCustomerDetails") {
      const { status } = _case;
      return <CaseBodyListActions status={status} lang={this.props.lang.currentLang.lang} />
    } else {
      const { entityId, status, gdocsTerms } = _case;
      return <CustList conflictStatus={status}
        gdocsTerms={gdocsTerms}
        passdata={entityId}
        deleteEntity={this.props.deleteEntity}
        statusOption={this.props.statusOption}
        gdocsTerms1={this.props.gdocsTerms1}
        gdocsTerms2={this.props.gdocsTerms2}
        gdocsTerms3={this.props.gdocsTerms3}
        lang={this.props.lang} />
    }
  }

  custVersionList(elements) {
    if (this.props.entites && Object.keys(this.props.entites).length === 0) {
      if (document.getElementById('wraplist') !== null) {
        document.getElementById('wraplist').className = 'addbodertop';
        document.getElementById('btnwrapperid').className = 'btnWrapper';
        document.getElementById('disabledFinsh').disabled = true
        document.getElementById('disablednextbt').disabled = true
        document.getElementById('disabledFinsh').classList.add('btndisable');
        document.getElementById('disablednextbt').classList.add('btndisable');
        document.getElementById('disablednextbt').classList.remove('btnbg');
      }
    }

    var entity;
    for (const entityId in this.props.entities) {
      entity = this.props.entities[entityId];
      let translatedEntity = this.props.countryList !== undefined ? this.getAccountCountryTaxanomy(entity) : entity;
      elements.push(
        <div key={entityId} className='navListSeparator'>
          <div className="gdocs-float-left navListCustHeading">
            <h3 className='linkCursor' onKeyDown={this.toViewEntityProfilePageOnEnter.bind(this, entity.entityId)} onClick={this.toViewEntityProfilePage.bind(this, entity.entityId)} tabIndex="0" role="link">
              {`${entity.entityName} - ${translatedEntity.cof && translatedEntity.cof.name ? translatedEntity.cof.name : ""}`}

            </h3>
          </div>
          {this.props.isClientImplementationManager &&
            Array.isArray(this.props.sowEntities) && this.props.sowEntities.length ?
            <section className='case-creation-sow-entity-map-dd gdocs-float-left gdocs-pt-4' >
              <SimpleDropdown
                options={this.props.getSowMappingToCaseOptions(translatedEntity)}
                showPleaseSelectOption={true}
                value={this.props.sowMappingToCases[entityId]}
                _onChange={(e) => {
                  this.props.handleSowMappingToCases(e.target.value, entityId, this.props.sowMappingToCases[entityId])
                }}
                optionTextSelector="registeredName"
                valueSelector="id"
                id={"sow-" + entityId}
                name={"sow-" + entityId}
                disabledOptions={Object.values(this.props.sowMappingToCases)}
              />
            </section>
            : null
          }
          <div className="gdocs-float-right">
            {this.checkResolve(entity)}
          </div>
          <div className="gdocs-clear-float"></div>
        </div>
      );
    }
  }

  caseBodyCustomerDetailsList(elements) {
    var entity, caseId;
    const customerDetailsStatuses = this.props.properties.customerDetailsStatuses || [];
    for (var entityId in this.props.entities) {
      let customerDetailsStatus = [];
      customerDetailsStatuses.forEach((cdStatus) => {
        if (cdStatus.id === entityId) {
          customerDetailsStatus = cdStatus;
        }
      });
      entity = this.props.entities[entityId];
      caseId = entity.caseId;
      elements.push(
        <NavlistWrapper key={entityId} block={this.props.cases && this.props.cases[caseId] && CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId].status] > 2 || this.props.caseMenu.isEditing}>
          <div key={entityId} className='navListSeparator'>
            <div className="gdocs-float-left navListCustHeading">
              <h3 className='linkCursor' onKeyDown={this.toCaptureCustomerDetailsOnEnter.bind(this, entity.entityId, entity.caseId)} onClick={this.toCaptureCustomerDetails.bind(this, entity.entityId, entity.caseId)} tabIndex="0" role="link">
                {entity.entityName}

              </h3>
            </div>
            <div className="gdocs-float-right">
              {this.checkResolve(customerDetailsStatus)}
            </div>
            <div className="gdocs-clear-float"></div>
          </div>
        </NavlistWrapper>
      );
    }
  }

  caseBodyAddNewCustomersList(elements) {
    if (this.props.entites && Object.keys(this.props.entites).length === 0) {
      if (document.getElementById('wraplist') !== null) {
        document.getElementById('wraplist').className = 'addbodertop';
        document.getElementById('btnwrapperid').className = 'btnWrapper';
        document.getElementById('disabledFinsh').disabled = true
        document.getElementById('disablednextbt').disabled = true
        document.getElementById('disabledFinsh').classList.add('btndisable');
        document.getElementById('disablednextbt').classList.add('btndisable');
        document.getElementById('disablednextbt').classList.remove('btnbg');
      }
    }
    var entity;
    for (var entityId in this.props.entities) {
      entity = this.props.entities[entityId];
      if (entity.caseId === undefined) {
        elements.push(
          <div key={entityId} className='navListSeparator'>
            <div className="gdocs-float-left navListCustHeading">
              <h3 className='linkCursor' onKeyDown={this.toViewEntityProfilePageOnEnter.bind(this, entity.entityId)} onClick={this.toViewEntityProfilePage.bind(this, entity.entityId)} tabIndex="0" role="link">
                {`${entity.entityName} - ${entity.cof.name}`}

              </h3>
            </div>
            <div className="gdocs-float-right">
              {this.checkResolve(entity)}
            </div>
            <div className="gdocs-clear-float"></div>
          </div>
        );
      }
    }
  }

  showList() {
    var listElements = [];
    switch (this.props.listtype) {
      case "custVersion": {
        this.custVersionList(listElements);
        break;
      }
      case "accountVersion": {
        this.accountVersionList(listElements);
        break;
      }
      case "echannelVersion": {
        this.accountVersionList(listElements);
        break;
      }
      case "GLSproducts": {
        this.accountVersionList(listElements);
        break;
      }
      case "caseBodyCustomerDetails": {
        this.caseBodyCustomerDetailsList(listElements);
        break;
      }
      case "caseBodyAddNewCustomersList": {
        this.caseBodyAddNewCustomersList(listElements);
        break;
      }
      case "caseBodyProductRequests": {
        this.allProductlist(listElements);
        break;
      }
      default:
        return listElements
    }
    return listElements;
  }

  _onCancleProductOk = () => {
    this.toggleDeleteProductDialog();
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    return (
      <div className={this.props.listtype === 'custVersion' ? 'listContainer' : 'listContainer removebdrtop'}>
        {this.showList()}

        <DeleteProductModal
          showDialog={this.state.showDeleteProductDialog}
          {...this.props.deleteModalContent}
          toggleDialog={this.toggleDeleteProductDialog}
          _onOk={this._onDeleteProductOk}
          _onCancle={this._onCancleProductOk}
          bsClass="delete-product-modal-content"
          lang={this.props.lang}
          translations={(word) => this.translations(word)}
        />
        {this.props.achPaymentModalContent ? <AchPaymentTypeModal
          showDialog={this.state.showAchPaymentTypeDialog}
          {...this.props.achPaymentModalContent}
          toggleDialog={this.toggleAchPaymentTypeDialog}
          _onOk={this._onAchProductTypeOk}
          _onCancle={this._onCancleAchPaymentType}
          bsClass="gdocs-cancel-request-modal-content"
          lang={this.props.lang}
          translations={(word) => this.translations(word)}
          achPaymentType={this.state.achPaymentType}
          _setRadioSelection={this.setRadioSelection}
        /> : null}
      </div>
    );
  }
}


const NavlistWrapper = (props) => {
  const navListWrapper = classnames("nav-list-wrapper", {
    block: props.block
  });
  return (
    <div className={navListWrapper}>
      <div className="nav-list-blocker"></div>
      {props.children}
    </div>
  )
}


/*MODAL FOR DELETING PRODUCT*/
const DeleteProductModal = (props) => {
  return (
    <Modal
      show={props.showDialog}
      onClose={props.toggleDialog}
      bsClass={props.bsClass}>
      <ModalHeader title={props.translations(props.modalTitle)}
      />
      <ModalBody>
        <p>{props.translations(props.par1)}</p>
      </ModalBody>
      <ModalFooter>
        <button
          className="gdocs-btn-default gdocs-mright-20 gdocs-mtop-20"
          onClick={props._onCancle}
        >
          {props.translations(props.whiteBtn)}
        </button>
        <button
          className="gdocs-btn-primary"
          onClick={props._onOk}
        >
          {props.translations(props.redBtn)}
        </button>
      </ModalFooter>
    </Modal>
  );
}

/*MODAL FOR ACH PAYMENT TYPES */
const AchPaymentTypeModal = (props) => {
  const translateWord = (word) => {
    var currentWord = Translations(word, props.lang.currentLang.lang, props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }
  return (
    <Modal
      show={props.showDialog}
      onClose={props.toggleDialog}
      bsClass={props.bsClass}>
      <ModalHeader title={props.translations(props.page_title_mainTitle.pageHeading)} />
      <ModalBody>
        <p>{props.translations(props.page_title_mainTitle.descriptionText)}</p>
        <div className="cancel-case-radio-btn">
          <div className="cancelCaseRadio">
            <Radio
              id="ach-subgroup-radio-1"
              name="radio"
              value={translateWord(props.modal_paymentTypeSelection.fieldLabels)[0]}
              _value={props.achPaymentType}
              setInputvalue={(event) => props._setRadioSelection(event)}
              tabIndex="0"
            />
            <label htmlFor="ach-subgroup-radio-1">
              {translateWord(props.modal_paymentTypeSelection.fieldLabels)[0]}
            </label>
          </div>
          <div className="cancelCaseRadio">
            <Radio
              id="ach-subgroup-radio-2"
              name="radio"
              value={translateWord(props.modal_paymentTypeSelection.fieldLabels)[1]}
              _value={props.achPaymentType}
              setInputvalue={(event) => props._setRadioSelection(event)}
              tabIndex="0"
            />
            <label htmlFor="ach-subgroup-radio-2">
              {translateWord(props.modal_paymentTypeSelection.fieldLabels)[1]}
            </label>
          </div>
          <div className="cancelCaseRadio">
            <Radio
              id="ach-subgroup-radio-3"
              name="radio"
              value={translateWord(props.modal_paymentTypeSelection.fieldLabels)[2]}
              _value={props.achPaymentType}
              setInputvalue={(event) => props._setRadioSelection(event)}
              tabIndex="0"
            />
            <label htmlFor="ach-subgroup-radio-3">
              {translateWord(props.modal_paymentTypeSelection.fieldLabels)[2]}
            </label>
          </div>
          <div className="cancelCaseRadio">
            <Radio
              id="ach-subgroup-radio-4"
              name="radio"
              value={translateWord(props.modal_paymentTypeSelection.fieldLabels)[3]}
              _value={props.achPaymentType}
              setInputvalue={(event) => props._setRadioSelection(event)}
              tabIndex="0"
            />
            <label htmlFor="ach-subgroup-radio-4" >
              {translateWord(props.modal_paymentTypeSelection.fieldLabels)[3]}
            </label></div>
          <div className="cancelCaseRadio">
            <Radio
              id="ach-subgroup-radio-5"
              name="radio"
              value={translateWord(props.modal_paymentTypeSelection.fieldLabels)[4]}
              _value={props.achPaymentType}
              setInputvalue={(event) => props._setRadioSelection(event)}
              tabIndex="0"
            />
            <label htmlFor="ach-subgroup-radio-5">
              {translateWord(props.modal_paymentTypeSelection.fieldLabels)[4]}
            </label>
          </div>
          <div className="cancelCaseRadio">
            <Radio
              id="ach-subgroup-radio-6"
              name="radio"
              value={translateWord(props.modal_paymentTypeSelection.fieldLabels)[5]}
              _value={props.achPaymentType}
              setInputvalue={(event) => props._setRadioSelection(event)}
              tabIndex="0"
            />
            <label htmlFor="ach-subgroup-radio-6">
              {translateWord(props.modal_paymentTypeSelection.fieldLabels)[5]}
            </label>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="gdocs-btn-default gdocs-mright-20 gdocs-mtop-20"
          onClick={props._onCancle}
        >
          {props.translations(props.modal_paymentTypeSelection.cancelButtonText)}
        </button>
        <button
          className="gdocs-btn-primary"
          disabled={props.achPaymentType === ''}
          onClick={props._onOk}
        >
          {props.translations(props.modal_paymentTypeSelection.addButtonText)}
        </button>
      </ModalFooter>
    </Modal>
  );
}

// <div onKeyDown={this.toCaptureProductAccountOnEnter.bind(this, account.id, account.caseId)}
//      onClick={this.toCaptureProductAccount.bind(this, account.id, account.caseId)}
//      className='navListAccHeading linkCursor' tabIndex="0" role="link">



// <NavlistWrapper key={account.id} block={CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[account.caseId].status] > 2 }>
//   <div className='navListSeparator'>
//     <div className="gdocs-float-left">
//       <Link to={'/case-body/capture-product-account/' + account.caseId + '/' + account.id}>
//         {`${account.accountType.name}, ${account.country.name}, ${account.currency.name}`}
//          
//       </Link>
//     </div>
//     <div className="navListDesc">
//       {`${account.accountHolder.name} (${account.accountTitle ? account.accountTitle + ', ' : ''}${account.tempRefrenceId})`}
//     </div>
//   </div>
//   <div className="gdocs-float-right">
//     <div className="gdocs-float-left">
//       <CaseBodyProductListStatus status={account.productStatus} />
//     </div>
//     <div className="separatorBar gdocs-float-left"></div>
//     <div className="icon icon-bin deleteIcon gdocs-float-left" tabIndex="0"
//     onClick={this.confrimDeleteProduct.bind(this, account.accountHolder.value, 'accounts', account.id)} >
//     </div>
//   </div>
//   <div className="gdocs-clear-float"></div>roleDetails.customer
// </NavlistWrapper>

const mapStateToProps = state => {
  return {
    caseMenu: state.caseMenuInfo,
    customer: state.auth.userDetails,
    lang: state.lang

  }
}

const mapDispatchToProps = dispatch => {
  return {
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps, null)(NavigationList);



// WEBPACK FOOTER //
// ./src/components/common/NavigationList/index.js